import { render, staticRenderFns } from "./send-resupply.modal.vue?vue&type=template&id=53b398c7&scoped=true"
import script from "./send-resupply.modal.vue?vue&type=script&lang=js"
export * from "./send-resupply.modal.vue?vue&type=script&lang=js"
import style0 from "./send-resupply.modal.vue?vue&type=style&index=0&id=53b398c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b398c7",
  null
  
)

export default component.exports